module.exports = __webpack_public_path__ + "static/compren-9efc087116ee85671219cfb0bb18913b.jpeg";